export default "__VITE_ASSET__CoXc4sPs__"